<template>
    <div id="ordersInfo">
        <div v-if="openOrders" class="card dashboardWidget">
            <div class="card-header">
                <h2>Open Orders</h2>
            </div>
            <div class="card-body">
                <dx-data-grid v-if="orders" id="gridContainer" :data-source="orders" :show-borders="true" key-expr="Id" :allow-column-reordering="true"
                              :allow-column-resizing="true">

                    <dx-paging :enabled="false" />
                    <dx-editing :use-icons="true" />

                    <dx-scrolling mode="infinite" />
                    <!--<dx-sorting mode="none" />-->
                    <dx-state-storing :enabled="true" type="localStorage" storage-key="openOrders" />


                    <dx-column :width="50" :buttons="onClickOrder" type="buttons" />
                    <dx-column data-field="SopNumber" caption="Order Number" />
                    <dx-column v-if="orders.InvoiceDate != null" data-field="InvoiceDate" caption="Order Date" />
                    <dx-column data-field="CustomerPoNumber" caption="PO Number" />
                    <dx-column data-field="OrganizationName" caption="Organization" />
                    <dx-column data-field="Created" caption="Order Date" :customizeText="toLocalTime" />

                </dx-data-grid>
            </div>
            <div v-if="openOrders" class="card-footer text-center text-muted ">
                <!--<p v-if="orders">  Number of Open Orders: {{this.orders.length}}</p>-->
            </div>
        </div>
    </div>

</template>
<script>
    import Formatters from '@/services/FormatterService.js'
    import LoadingAnimation from '@/components/general/LoadingAnimation.vue'

    import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxPaging, DxScrolling } from 'devextreme-vue/data-grid';
    import Moment from 'moment';

    var moment = new Moment();
    export default {
        props: {
            openOrders: {
                type: Array,
                default: () => { }
            }
        },
        components: {
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxPaging,
            DxScrolling,
            LoadingAnimation,
            DxStateStoring
        },
        data: function () {
            return {
                orders: null,

                onClickOrder: ['info', {
                    hint: "Order Details",
                    icon: 'fas fa-info-circle',
                    onClick: this.iconClick
                }],
            }
        },
        methods: {
            formatDateTime(value) {
                return Formatters.formatDateTime(value)
            },
            iconClick(orders) {
                //onclick of info icon pushes to path along with id from what was clicked
                window.location.href = '/dice/orders/' + orders.row.data.Id;
            },
            openOrder() {
                let open = []
                for (let x in this.openOrders) {
                    if (this.openOrders[x]._sopType == 2) {
                        open.push(this.openOrders[x])
                    }
                }
                this.orders = open;

            },
            toLocalTime(e) {
   let localDate = new Date(e.value).toLocaleString();
                return localDate = localDate.split(',')[0]
            }
        },
        mounted() {
            this.openOrder()
        }
    }
</script>

<style scoped>
    #gridContainer {
        height: 254px;
    }

    #ordersInfo .dx-datagrid .dx-link {
        width: 1px;
    }

    .dashboardWidget {
        padding-bottom: 2.25rem;
    }
</style>